function getEvents(pageId) {
  return {
    events: {
      e: {
        id: "e",
        name: "",
        animationType: "preset",
        eventTypeId: "SLIDER_ACTIVE",
        action: {
          id: "",
          actionTypeId: "GENERAL_START_ACTION",
          config: {
            delay: 0,
            easing: "",
            duration: 0,
            actionListId: "a",
            affectedElements: {},
            playInReverse: false,
            autoStopEventId: "e-2",
          },
        },
        mediaQueries: ["main", "medium", "small", "tiny"],
        target: {
          id: `${pageId}|slide`,
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
        targets: [
          {
            id: `${pageId}|slide`,
            appliesTo: "ELEMENT",
            styleBlockIds: [],
          },
        ],
        config: {
          loop: false,
          playInReverse: false,
          scrollOffsetValue: null,
          scrollOffsetUnit: null,
          delay: null,
          direction: null,
          effectIn: null,
        },
        createdOn: 1641822487291,
      },
      "e-2": {
        id: "e-2",
        name: "",
        animationType: "preset",
        eventTypeId: "SLIDER_INACTIVE",
        action: {
          id: "",
          actionTypeId: "GENERAL_START_ACTION",
          config: {
            delay: 0,
            easing: "",
            duration: 0,
            actionListId: "a-2",
            affectedElements: {},
            playInReverse: false,
            autoStopEventId: "e-1473",
          },
        },
        mediaQueries: ["main", "medium", "small", "tiny"],
        target: {
          id: `${pageId}|slide`,
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
        targets: [
          {
            id: `${pageId}|slide`,
            appliesTo: "ELEMENT",
            styleBlockIds: [],
          },
        ],
        config: {
          loop: false,
          playInReverse: false,
          scrollOffsetValue: null,
          scrollOffsetUnit: null,
          delay: null,
          direction: null,
          effectIn: null,
        },
        createdOn: 1641822487291,
      },
    },
    actionLists: {
      a: {
        id: "a",
        title: "Gallery 14 [Slide In]",
        actionItemGroups: [
          {
            actionItems: [
              {
                id: "a-n",
                actionTypeId: "STYLE_OPACITY",
                config: {
                  delay: 0,
                  easing: "ease",
                  duration: 500,
                  target: {
                    useEventTarget: "CHILDREN",
                    selector: ".gallery13_image-wrapper",
                    selectorGuids: ["430275db-849f-d8c9-d410-6444a1d5c4d2"],
                  },
                  value: 1,
                  unit: "",
                },
              },
            ],
          },
        ],
        useFirstGroupAsInitialState: false,
        createdOn: 1641817235748,
      },
      "a-2": {
        id: "a-2",
        title: "Gallery 14 [Slide Out]",
        actionItemGroups: [
          {
            actionItems: [
              {
                id: "a-2-n",
                actionTypeId: "STYLE_OPACITY",
                config: {
                  delay: 0,
                  easing: "ease",
                  duration: 500,
                  target: {
                    useEventTarget: "CHILDREN",
                    selector: ".gallery13_image-wrapper",
                    selectorGuids: ["430275db-849f-d8c9-d410-6444a1d5c4d2"],
                  },
                  value: 0.3,
                  unit: "",
                },
              },
            ],
          },
        ],
        useFirstGroupAsInitialState: false,
        createdOn: 1641817235748,
      },
    },
    site: {
      mediaQueries: [
        { key: "main", min: 992, max: 10000 },
        {
          key: "medium",
          min: 768,
          max: 991,
        },
        { key: "small", min: 480, max: 767 },
        { key: "tiny", min: 0, max: 479 },
      ],
    },
  };
}

// eslint-disable-next-line import/no-default-export
export default getEvents;
